import { Injectable } from '@angular/core';
import { SelfV2 } from 'src/app/core/alcmeon-context/models/self-v2.model';
import { SiteV2 } from 'src/app/shared/models';
import { TaskStateInWsNotif } from 'src/app/shared/models/misc.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import { StrategiesService } from 'src/app/shared/strategies/strategies.service';

import { QueueIdEnum } from '../../inbox/shared/enums';
import { TaskListConfiguration } from '../../inbox/shared/models';
import { ChannelStockConfig } from '../shared/models';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';

@Injectable({
  providedIn: 'root',
})
export class PushboxConfigurationService {
  constructor(
    private basicService: BasicService,
    private strategiesService: StrategiesService,
    private alcmeonContextService: AlcmeonContextService
  ) {}

  /**
   * There is only one conf, corresponding to the only button "ongoing by me" and the related task list.
   */
  getPushboxConfiguration(siteIds: number[], routingTagsIds: number[], loggedUser: SelfV2): TaskListConfiguration {
    return {
      title: `${this.basicService.translate('inbox/tab/ongoing')} ${this.basicService.translate('inbox/tab/by-me')}`,
      queueId: QueueIdEnum.AssignedToYou,
      counterIndex: 0,
      parameters: {
        sites_ids: siteIds,
        states: [TaskStateInWsNotif.Assigned, TaskStateInWsNotif.OnHold, TaskStateInWsNotif.HelpRequested],
        routingTagsIds: routingTagsIds,
        admin_users_ids: [loggedUser.id],
      },
    };
  }

  /**
   * Get all channels, used only for counters, not navigation.
   */
  getChannelsConfiguration(sitesForConfigs: SiteV2[]): ChannelStockConfig[] {
    const channels: ChannelStockConfig[] = [
      {
        tasks_ids: [],
        taskTypeString: this.basicService.translate('pushbox/channels/all'),
        taskTypes: [],
      },
    ];

    const stategiesToDisplay = this.strategiesService
      .getAll()
      .filter(strategy => sitesForConfigs.some(site => site.type === strategy.getType()));

    stategiesToDisplay.forEach(strategy => {
      const tasks = strategy.getAllTasksTypesForInbox();
      this.alcmeonContextService.addPublicRepliesTaskIfAllowed(strategy, tasks);
      tasks.forEach(taskType => {
        channels.push({
          tasks_ids: [],
          typeString: strategy.getTypeString(),
          taskTypeString: this.basicService.translate(`inbox/channels/${strategy.getTaskTypeString(taskType)}`),
          taskTypes: [taskType],
        });
      });
    });

    return channels;
  }
}
